<style src='./style.scss'>

</style>

<div class="mbsc-card member-details-card">
    <div class="mbsc-card-header">
        <div class="mbsc-card-title">Preferencias</div>
    </div>
    <div class="mbsc-card-content">
      {#if member}
      <label class="mbsc-padding">
        Nombre de usuario:
          <span>{member.attributes.email}</span>
      </label>
      {#if member.attributes['custom:isStaff'] === "1"}
      <label class="mbsc-padding">
        Staff:
          <span>Si</span>
      </label>
      {/if}
      {/if}
      <label class="mbsc-checkbox-primary">
        Correo verificado
        <input mbsc-checkbox type="checkbox" disabled class="email-verified">
      </label>
      <label>
        <select mbsc-dropdown id="genero" name="genero" required data-icon="user4">
          <option value="female">Femenino</option>
          <option value="male">Masculino</option>
          <option value="other">Otro</option>
          <option value="prefer-no">Prefiero no decir</option>
        </select>
      </label>
      <label class="mbsc-checkbox-primary">
        Me gustaría recibir correos electrónicos sobre productos, servicios y contenido relevante basado en mi actividad.
        <input mbsc-checkbox type="checkbox" class="signed-to-mktg">
      </label>
    </div>
    <div class="mbsc-btn-group-block mbsc-padding">
        <button class="mbsc-button mbsc-btn-primary" on:click={updateMember}>Actualizar</button>
    </div>
</div>

<div class="mbsc-col-12">
  <section class="mbsc-align-right">
    <button class="mbsc-button mbsc-btn-danger" on:click={signOut}>Cerrar Sesión</button>
  </section>
</div>

<script>
  import { onMount, afterUpdate } from 'svelte';
  import { AWSAuth, Navigation } from '@Services';

  const DEBUG = document.location.protocol === 'http:' ? true : false;

  let member = null;

  let signOut = async () => {
    const response = await AWSAuth.signOut();
    Navigation.goTo('home');
    if (DEBUG) console.log('Logged off');
  };

  let updateMember = async () => {
    if (DEBUG) console.log('Updating member');
    AWSAuth.updateMember(member, {
      'custom:signedOnToMarketing': document.querySelector('.signed-to-mktg').checked ? 'y': 'n',
      'gender': document.querySelector('#genero').value,
    }).then(response => {
      if (response === 'SUCCESS') {
        mobiscroll.toast({message: 'Tus datos han sido actualizados'});
      }
    })
  };

  afterUpdate(() => {});

  onMount(async () =>{
    mobiscroll.settings = {
      theme: 'd-ns',
      themeVariant: 'light',
      lang: 'es'
    };

    mobiscroll.card('.member-details-card', {});

    AWSAuth.getUser().then(response => {
      if (typeof member === 'string' && member === 'not authenticated') {
        Navigation.goTo('home');
      }else{
        member = response;

        document.querySelector('.email-verified').checked = member.attributes['custom:signedOnToMarketing'];

        let signedOnToMarketing = member.attributes['custom:signedOnToMarketing'] === 'y' ? true : false;
        document.querySelector('.signed-to-mktg').checked = signedOnToMarketing;

        mobiscroll.$('#genero').val(member.attributes['gender']).trigger('change');
      }
    });
  });
</script>
